import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/management/stationless')({
  component: Outlet,
  beforeLoad: () => ({
    breadcrumb: 'Alle',
  }),
});
